<template>
  <a-select
    :options="options"
    v-model.sync="localValue"
    :has-teleport="!outsideModal"
    :missing-option-error-message="missingOptionErrorMessage"
  >
  </a-select>
</template>

<script lang="ts">
  import Vue from "vue";
  import {IVOptionSetLocal} from "../../../interfaces/vSelectInterfaces";
  import LocalValueEmissionMixin from "../../../mixins/localValueEmissionMixin";

  export default Vue.extend({
    props: ['value', 'type', 'referencedControl', 'outsideModal'],
    mixins: [LocalValueEmissionMixin],
    data() {
      return {
      }
    },
    computed: {
      options(): IVOptionSetLocal {
        return {
          valueKey: 'client_id',
          labelKey: 'label_title',
          options: this.referencedControl.getChoiceComparisonOptions()
        }
      },
      missingSelectedOption(): boolean {
        return this.localValue && !this.options.options.find(o => o[this.options.valueKey] === this.localValue);
      },
      missingOptionErrorMessage(): string {
        if (this.missingSelectedOption) {
          return 'Value no longer exists';
        }
      },
    }
  });
</script>
